import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * The Accounting & Finance sub-navigation (PART 11's menu group as built so
 * far): Chart of Accounts (FIN-01), Journal Entries (FIN-02), Receipt
 * Vouchers (FIN-03, the group's landing route), Payment Vouchers (FIN-04),
 * Currency Exchange (FIN-05), Fixed Assets (FIN-07) and E-Invoicing
 * (FIN-08) — 16.2.2 row 6 puts
 * "foreign exchange, fixed assets" in this area, and FIN-05 §3 fixes the
 * label collision in favour of the rate-management reading.
 */
const TABS = [
  { to: '/accounting', end: true, key: 'acct.tabReceipts' },
  { to: '/accounting/payments', end: false, key: 'acct.tabPayments' },
  { to: '/accounting/journals', end: false, key: 'acct.tabJournals' },
  // Q-FIN-01-3's screen — the glossary's "[NOT IN PROTOTYPE — decide at build
  // time]" under G-CLOSEDPERIOD, decided here: 16.2.2 row 6 puts fiscal
  // periods in the accounting area, and the question that asked for it is
  // FIN-01's.
  { to: '/accounting/periods', end: false, key: 'acct.tabPeriods' },
  { to: '/accounting/currencies', end: false, key: 'acct.tabCurrencies' },
  { to: '/accounting/assets', end: false, key: 'acct.tabAssets' },
  { to: '/accounting/einvoicing', end: false, key: 'acct.tabEinvoicing' },
  // Last on purpose (bugs: Accounting & Finance) — the chart is set up once
  // and visited rarely; the daily vouchers come first.
  { to: '/accounting/chart', end: false, key: 'acct.tabChart' },
] as const;

export function AccountingTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navAccounting')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
